"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Key, MessageCircle } from "lucide-react";
export default function CallToAction() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: scarcityRef,
    isVisible: scarcityVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="call-to-action" className="w-full bg-[#001F3F] py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="flex flex-col items-center text-center space-y-6">
          <h2 ref={headlineRef} className="font-[var(--font-cinzel)] font-bold tracking-[4px] leading-[1.35] text-[#D4AF37] px-8 py-6 rounded-lg transition-all duration-[180ms] ease-out opacity-100 translate-y-0 !text-[40px]">Your Family Wisdom Legacy is Waiting to be Curated with Love</h2>

          <p ref={copyRef} className={`font-[var(--font-libre-baskerville)] text-lg md:text-xl leading-[1.6] text-[#FDFDF5] max-w-2xl transition-all duration-[180ms] ease-out delay-100 ${copyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>Join my intake of six families for a dedicated six-week journey through the "nine life pillar" framework. Let's ensure your wisdom isn't just a memory, but a permanent foundation for those you love. Applications for my first intake is now open.</p>

          <div ref={ctaRef} className={`flex flex-col items-center gap-2 transition-all duration-700 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Link to="https://calendly.com/ancelfernandes/30-min-strategy-call">
              <Button className="w-full sm:w-auto bg-[hsl(45,65%,52%)] text-[hsl(210,100%,12%)] hover:bg-[hsl(45,65%,48%)] font-[var(--font-montserrat)] font-bold tracking-wider text-sm sm:text-lg px-4 sm:px-10 py-3 sm:py-6 leading-tight shadow-lg hover:shadow-xl transition-all duration-300">BOOK COMPLIMENTARY CONSULTATION CALL</Button>
            </Link>
            
            <p className="font-[var(--font-libre-baskerville)] text-[15px] italic text-[#B8B8B8] flex items-center justify-center gap-2 mt-2.5 mb-4">
              <Key className="size-4" />
              <span>Includes a private viewing of <em>The Heritage Experience</em> and <em>The Heritage Compendium</em>.</span>
            </p>

            <Link to="https://wa.me/971504585183?text=I%20am%20interested%20in%20learning%20more%20about%20how%20I%20could%20preserve%20my%20family%20wisdom%20legacy.">
              <Button variant="ghost" className="border-2 border-[#D4AF37] text-[#D4AF37] bg-transparent hover:bg-[#D4AF37] hover:text-white font-[var(--font-montserrat)] font-bold tracking-wider text-sm px-8 py-5 shadow-md hover:shadow-lg transition-all duration-300 mt-[15px]">
                <MessageCircle className="size-5" />
                ENQUIRE VIA WHATSAPP
              </Button>
            </Link>
          </div>

          <p ref={scarcityRef} className={`font-[var(--font-montserrat)] font-light text-sm text-[#FDFDF5] transition-all duration-[180ms] ease-out delay-300 ${scarcityVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
            Only 6 families accepted per intake to ensure bespoke, personal curation.
          </p>
        </div>
      </div>
    </section>;
}